<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M3.88534 5.2371C3.20538 5.86848 2.75 6.89295 2.75 8.5V15.5C2.75 17.107 3.20538 18.1315 3.88534 18.7629C4.57535 19.4036 5.61497 19.75 7 19.75H17C18.385 19.75 19.4246 19.4036 20.1147 18.7629C20.7946 18.1315 21.25 17.107 21.25 15.5V8.5C21.25 6.89295 20.7946 5.86848 20.1147 5.2371C19.4246 4.59637 18.385 4.25 17 4.25H7C5.61497 4.25 4.57535 4.59637 3.88534 5.2371ZM2.86466 4.1379C3.92465 3.15363 5.38503 2.75 7 2.75H17C18.615 2.75 20.0754 3.15363 21.1353 4.1379C22.2054 5.13152 22.75 6.60705 22.75 8.5V15.5C22.75 17.393 22.2054 18.8685 21.1353 19.8621C20.0754 20.8464 18.615 21.25 17 21.25H7C5.38503 21.25 3.92465 20.8464 2.86466 19.8621C1.79462 18.8685 1.25 17.393 1.25 15.5V8.5C1.25 6.60705 1.79462 5.13152 2.86466 4.1379Z"
      fill="#5A627D"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="M19.3633 7.3105C19.6166 7.63826 19.5562 8.10928 19.2285 8.36254L13.6814 12.6488C12.691 13.414 11.3089 13.414 10.3185 12.6488L4.77144 8.36254C4.44367 8.10928 4.38328 7.63826 4.63655 7.3105C4.88982 6.98273 5.36083 6.92234 5.6886 7.17561L11.2356 11.4618C11.6858 11.8097 12.3141 11.8097 12.7642 11.4618L18.3113 7.17561C18.6391 6.92234 19.1101 6.98273 19.3633 7.3105Z"
      fill="#5A627D"
      fill-opacity="0.5"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'NlpSubscribeEmail',
}
</script>